import { OneWayInServiceDto, PublicationState } from 'src/api/v2';

export enum ServiceStatuses {
  Active = 'active',
  Inactive = 'inactive',
  Draft = 'draft',
}

type DateInput = Date | string | null | undefined;

export type ServiceDateValidity = {
  isActive: boolean;
  validFromInFuture: boolean;
  validToExpired: boolean;
};

// Date-only strings (from <input type="date">) are local days, not UTC midnight.
const startOfLocalDay = (value: Date | string): Date => {
  const date =
    typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
      ? new Date(`${value}T00:00:00`)
      : new Date(value);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};

export function getServiceDateValidity(
  validFrom: DateInput,
  validTo: DateInput,
  now: Date = new Date(),
): ServiceDateValidity {
  const today = startOfLocalDay(now);
  const validFromInFuture = !!validFrom && startOfLocalDay(validFrom) > today;
  const validToExpired = !!validTo && startOfLocalDay(validTo) < today;
  return {
    isActive: !!validFrom && !!validTo && !validFromInFuture && !validToExpired,
    validFromInFuture,
    validToExpired,
  };
}

export function isValidityRangeReversed(validFrom: DateInput, validTo: DateInput): boolean {
  return !!validFrom && !!validTo && startOfLocalDay(validTo) < startOfLocalDay(validFrom);
}

export function getServiceStatus(service: OneWayInServiceDto): ServiceStatuses {
  if (
    service.state === PublicationState.Active &&
    getServiceDateValidity(service.validFrom, service.validTo).isActive
  ) {
    return ServiceStatuses.Active;
  }
  if (service.state === PublicationState.Draft) {
    return ServiceStatuses.Draft;
  }
  return ServiceStatuses.Inactive;
}
